import { Socket } from "phoenix";
import userHub from "@/services/hubs/user";
import versionHub from "@/services/hubs/version";
import { Subject } from "rxjs";

class ChannelManagement {
  constructor() {
    this.channels = {};
    userHub.registerListener(user => {
      // logged out
      if (!user.id && this.socket) {
        this.socket.disconnect();
        this.socket = undefined;
      } else if (user.id) {
        this.socket = new Socket(process.env.VUE_APP_API_SOCKET, {
          params: { user_id: user.id }
        });
        this.socket.connect();
        this.getVersionChannel();
      }
    });
  }

  getChannel(channelName, prefix = "room") {
    if (!this.channels[channelName]) {
      let messages = new Subject();
      let channel = this.socket.channel(`${prefix}:${channelName}`);
      channel.on("msg", payload => {
        messages.next(payload);
      });
      channel.join();

      this.channels[channelName] = {
        messages,
        push(msg) {
          channel.push("msg", msg);
        }
      };
    }
    return this.channels[channelName];
  }

  getVersionChannel() {
    if (!this.channels["version:version"]) {
      // console.log("Connecting to versioning service...");
      let versionChannel = this.socket.channel("version:version");
      versionChannel.on("msg", payload => {
        versionHub.update(payload["version"]);
      });
      versionChannel.join();
      // .receive("ok", () => console.log("Connected to versioning service"));
    }
  }
}

export default new ChannelManagement();
